import { useEffect, useRef, useState, type ReactNode } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/store'
import { isPublicAuthPath } from '@/utils/authRedirect'
import {
  TALK_PATH,
  consumeLandscapePath,
  isTalkWelt,
  rememberLandscapePath,
} from '@/utils/talkWelt'
import { TalkWelt } from './TalkWelt'
import './talk-welt.css'

export function TalkGate({ children }: { children: ReactNode }) {
  const location = useLocation()
  const navigate = useNavigate()
  const isAuthenticated = useAuthStore(s => s.isAuthenticated)
  const isLoading = useAuthStore(s => s.isLoading)
  const user = useAuthStore(s => s.user)
  const [, setTick] = useState(0)
  const wasTalk = useRef(false)

  useEffect(() => {
    const bump = () => setTick(n => n + 1)
    window.addEventListener('resize', bump)
    window.addEventListener('orientationchange', bump)
    const mq = window.matchMedia?.('(orientation: portrait)')
    mq?.addEventListener?.('change', bump)
    return () => {
      window.removeEventListener('resize', bump)
      window.removeEventListener('orientationchange', bump)
      mq?.removeEventListener?.('change', bump)
    }
  }, [])

  const publicPath = isPublicAuthPath(location.pathname)
  const schoolPick = location.pathname === '/engineer/schools'
  const talk = Boolean(!isLoading && isAuthenticated && user && !publicPath && !schoolPick && isTalkWelt() && user.talk_enabled !== false)

  useEffect(() => {
    if (schoolPick) {
      wasTalk.current = false
      return
    }
    if (talk) {
      if (location.pathname !== TALK_PATH) {
        rememberLandscapePath(`${location.pathname}${location.search}`)
        navigate(TALK_PATH, { replace: true })
      }
      wasTalk.current = true
      return
    }
    if (wasTalk.current) {
      wasTalk.current = false
      const dest = consumeLandscapePath(user?.role)
      if (location.pathname === TALK_PATH || location.pathname !== dest.split('?')[0]) {
        navigate(dest, { replace: true })
      }
    } else if (location.pathname === TALK_PATH && isAuthenticated) {
      navigate(consumeLandscapePath(user?.role), { replace: true })
    }
  }, [talk, schoolPick, location.pathname, location.search, navigate, isAuthenticated, user?.role])

  if (talk) return <TalkWelt />
  return <>{children}</>
}
